import { startsWith } from 'lodash';

export function formatCompanyUrlForHyperlink(url) {
  if (url) {
    // if url exists, format and return it
    url = (startsWith(url, 'https')) ? url.slice(8) : url;
    url = (startsWith(url, 'http')) ? url.slice(7) : url;
  } else {
    // if url is a falsey value, return empty string
    url = '';
  }
  return url;
}

export function extractCompanyUrlFromEmail(email) {
  // strip characters before '@'
  // split remaining domain on '.' and take the last two parts

  // user@domain.com => domain.com
  // user@mail.domain.com => domain.com

  const parts = email.replace(/.*@/, '').split('.');
  if (parts.length < 2) return email;
  return `${parts[parts.length - 2]}` + '.' + `${parts[parts.length - 1]}`;

}



// WEBPACK FOOTER //
// ./shared/lib/formatCompanyUrl.js